import { CreditCardForm } from 'components/creditCardForm/creditCardForm';
import { BillingAddressForm } from 'components/billingAddressForm/billingAddressForm';
import { CreditCardList } from 'components/creditCardList/creditCardList';
import { StripeElementsForm } from 'components/stripeElementsForm/stripeElementsForm';
import { CheckoutWithPaypalSdkAcp } from 'components/checkoutWithPaypalSdkAcp/checkoutWithPaypalSdkAcp';
import { PaypalSdkService } from './../../services/paypalSdk.service';

import template from './paymentMethodForm.html';
import './paymentMethodForm.scss';

export const PaymentMethodForm = angular
    .module('checkout.components.paymentMethodForm', [
        CheckoutWithPaypalSdkAcp,
        CreditCardForm,
        BillingAddressForm,
        CreditCardList,
        StripeElementsForm,
        PaypalSdkService
    ]).component('paymentMethodForm', {
        template,
        bindings: {
            storeInfo: '<',
            availablePaymentMethods: '<',
            selectedPaymentMethod: '=',
            creditCardModel: '=',
            billingAddressModel: '=',
            billingSameAsShipping: '<',
            onCreditCardTypeUpdated: '<',
            stripeElementsCard: '<',
            onStripeElementsCardChange: '<',
            isShippingRequired: '<'
        },
        controller: class PaymentMethodForm {
            constructor(paypalSdkService) {
                angular.extend(this, { paypalSdkService });
            }
            $onInit() {
                this.paypalSdkService.renderPaypalMessages();
            }
            shouldShowPayPalAcpFields() {
                const paypalAcpEnabled = this.storeInfo.paypal &&
                    this.storeInfo.paypal.acpStatus === 'SUBSCRIBED' &&
                    !this.storeInfo.paypal.acpLimitReached;
                const authorizeNetEnabled = this.storeInfo.authorizeNet && this.storeInfo.authorizeNet.isEnabled;
                const stripeEnabled = this.storeInfo.acceptsStripeAsPayment;
                return !authorizeNetEnabled && !stripeEnabled && paypalAcpEnabled;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/paymentMethodForm/paymentMethodForm.js